import {
  AccountingReportDateOption,
  IncomeStatementDateOption,
  TrialBalanceGroupByOption,
} from 'further-types/lp/general-ledger';
import { z } from 'zod';
import { CalendarDay } from '../../../utils';
import { isMongoId, withSortableParams } from '../../helpers';

const TransactionDateRangeInput = z.object({
  startDate: z.instanceof(CalendarDay).optional(),
  endDate: z.instanceof(CalendarDay),
});

export const ListTransactionsInput = withSortableParams(
  TransactionDateRangeInput.extend({
    searchQuery: z.string().optional(),
    commitmentId: z.string().refine(isMongoId()).optional(),
  }),
  [
    'accountLabel',
    'accountSection',
    'transactionType',
    'transactionDate',
    'vatRate',
    'amountIncVatLcy',
    'amountIncVatTcy',
    'transactionCurrency',
    'description',
    'counterpartyLabel',
    'counterpartyRef',
    'createdByLabel',
    'bankAccountLabel',
  ],
);

export const ExportTransactionListInput = TransactionDateRangeInput.extend({
  searchQuery: z.string().optional(),
});

export const TrialBalanceInput = z.object({
  vehicleId: z.string(),
  dateOption: z.nativeEnum(AccountingReportDateOption),
  customDate: z.instanceof(CalendarDay).optional(),
  groupBy: z.nativeEnum(TrialBalanceGroupByOption),
});

export const IncomeStatementInput = z.object({
  vehicleId: z.string(),
  dateOption: z.nativeEnum(IncomeStatementDateOption),
  customDateRange: z
    .object({
      startDate: z.instanceof(CalendarDay),
      endDate: z.instanceof(CalendarDay),
    })
    .optional(),
});

export const CashFlowStatementInput = z.object({
  vehicleId: z.string(),
  dateOption: z.nativeEnum(IncomeStatementDateOption),
  customDateRange: z
    .object({
      startDate: z.instanceof(CalendarDay),
      endDate: z.instanceof(CalendarDay),
    })
    .optional(),
});

export const ScheduleOfInvestmentsInput = z.object({
  vehicleId: z.string(),
  dateOption: z.nativeEnum(AccountingReportDateOption),
  customDate: z.instanceof(CalendarDay).optional(),
});
